import SideMenu from "../../../ui/SideMenu";
import useFetchIntegratedExchanges from "../../../hooks/api/useFetchIntegratedExchanges";
import useFetchExchanges from "../../../hooks/api/useFetchExchanges";
import { useDispatch, useSelector } from "react-redux";
import styles from "../../../styles/Components/mini-app/mini-exchanges-menu/MiniExchangesMenu.module.css";
import { Skeleton, Spin } from "antd";
import { useMemo, useState } from "react";
import { FaCircleArrowRight } from "react-icons/fa6";
import { setSelectedPortfolioExchange } from "../../../redux/exchange/actions";
import useUserData from "../../../hooks/useUserData";
import { closeSideMenu } from "../../../redux/ui/uiSlice";
import { ConnectToExchangeStepTwo } from "../../../shared/connect-to-exchange/ExchangeConnectionSettingsMenu";
import capitalize from "antd/es/_util/capitalize";
import { FaAngleLeft } from "react-icons/fa";

function MiniExchangesMenu() {
  const {
    exchangeState: {
      integratedData,
      integratedDataLoading,
      exchangesLoading,
      exchangesError,
      confirmedExchanges,
    },
  } = useSelector((state) => state);

  const [step, setStep] = useState(1);
  const [targetExchange, setTargetExchange] = useState(null);

  const dispatch = useDispatch();

  const { email, username } = useUserData();

  useFetchIntegratedExchanges();
  useFetchExchanges();

  const isLoading = !confirmedExchanges?.length && exchangesLoading;
  const integratedExchanges = integratedData?.filter((ex) => {
    let commonExchanges = [];
    confirmedExchanges?.forEach((confirmedEx) => {
      if (confirmedEx?.id === ex.id) {
        commonExchanges.push(confirmedEx?.id);
      }
    });
    return ex.id !== "cryptocrispy" && !commonExchanges?.includes(ex?.id);
  });

  const selectExchangeHandler = (ex) => () => {
    const connectedExchange = integratedData?.find(
      (connectedEx) => connectedEx?.id === ex.id,
    );

    if (connectedExchange) {
      if (connectedExchange?.status !== "Active") {
        setStep(2);
        setTargetExchange(connectedExchange?.id);
      } else {
        dispatch(
          setSelectedPortfolioExchange(connectedExchange?.id, username, email),
        );
        dispatch(closeSideMenu());
      }
    } else {
      setStep(2);
      setTargetExchange(ex?.id);
    }
  };

  const goToSetting = (e, ex) => {
    e.stopPropagation();
    setStep(2);
    setTargetExchange(ex);
  };

  const resetMenu = () => {
    setStep(1);
    setTargetExchange(null);
  };

  return (
    <SideMenu
      title={
        step === 1
          ? "Exchanges"
          : `Tweak settings for ${capitalize(targetExchange)}`
      }
      scope="mini-exchanges"
      className={styles.menu}
      closeHandler={resetMenu}
    >
      {step === 1 ? (
        <ul className={styles.exchangeList}>
          {/*{isLoading}*/}
          {isLoading
            ? Array.from({ length: 5 }).map((_, i) => (
                <li key={i}>
                  <Skeleton.Node active className={styles.skeleton} />
                </li>
              ))
            : [...confirmedExchanges, ...integratedExchanges]?.map(
                (confirmedEx) => (
                  <li
                    key={confirmedEx?.id}
                    className={styles.exchangeItem}
                    onClick={selectExchangeHandler(confirmedEx)}
                  >
                    <span className={styles.exchangeName}>
                      {confirmedEx?.name}
                    </span>
                    {integratedDataLoading ? (
                      <Skeleton.Node className={styles.loadingStatus} active />
                    ) : (
                      <div
                        className={`${styles.action} ${
                          integratedData?.find(
                            (ex) => ex.id === confirmedEx?.id,
                          )?.status === "Active"
                            ? styles.connected
                            : ""
                        }`}
                        onClick={(e) => goToSetting(e, confirmedEx?.id)}
                      >
                        <span>
                          {integratedData?.find(
                            (ex) => ex.id === confirmedEx?.id,
                          )?.status !== "Active"
                            ? "Link"
                            : "Connected"}
                        </span>
                        <FaCircleArrowRight size={18} />
                      </div>
                    )}
                  </li>
                ),
              )}
        </ul>
      ) : (
        <div className={styles.settings}>
          <span className={styles.backBtn} onClick={() => setStep(1)}>
            <FaAngleLeft /> Back
          </span>
          <ConnectToExchangeStepTwo targetExchange={targetExchange} />
        </div>
      )}
    </SideMenu>
  );
}

export default MiniExchangesMenu;
